import { useSuspenseQuery } from '@apollo/client/react'
import { HugeiconsIcon } from '@hugeicons/react'
import { InformationCircleIcon } from '@hugeicons/core-solid-rounded'
import { goodie as goodieHelpers } from '@guestgoodie/helpers'
import { useLingui } from '@lingui/react/macro'

import {
  SharedAPI,
  getFragment,
  FragmentType,
  AdminAPI
} from '@guestgoodie/graphql'

import Button from '../../../components/ui/Button'

function Tile({
  title,
  info,
  token,
  price
}: {
  token: string
  title: string
  info?: string | null
  price?: string | null
}) {
  const { t } = useLingui()

  return (
    <article
      className="flex w-full flex-col rounded bg-white p-5"
      data-testid={`GoodieTile-${token}`}
    >
      <div className="flex w-full flex-row items-center">
        <div className="flex flex-1 flex-col gap-1">
          <h3 className="text-regular text-text">{title}</h3>
          <div className="flex flex-row items-center gap-1">
            <HugeiconsIcon
              icon={InformationCircleIcon}
              className="text-info size-4"
            />
            <span className="text-small text-text-light">{info}</span>
          </div>
        </div>
        <div className="h-full">
          <Button disabled>{price ?? t`Request`}</Button>
        </div>
      </div>
    </article>
  )
}

export default function GoodieTile({
  id,
  titleFilter
}: {
  id: number
  titleFilter?: string
}) {
  const { data } = useSuspenseQuery(AdminAPI.goodie.GET, {
    variables: { id }
  })

  const goodie = getFragment(
    SharedAPI.goodie.GOODIE_FRAGMENT,
    data?.getGoodie as FragmentType<typeof SharedAPI.goodie.GOODIE_FRAGMENT>
  )

  if (titleFilter && !goodie.title.includes(titleFilter)) return null

  return (
    <Tile
      title={goodie.title}
      info={goodieHelpers.toInfoFromGoodieFragment(goodie)}
      token={goodie.token}
      price={goodieHelpers.toPriceFromGoodieFragment(goodie)}
    />
  )
}
